import { Button } from "antd";
import classNames from "classnames";
import { memo } from "react";
import styled from "styled-components";
import { clazz } from "utils/common-util";

const ModalTemplate1 = ({
  title,
  titleComp,
  onBack,
  onClose,
  body,
  footer,
  titleClass,
  bodyClass,
  children,
  ...props
}) => {
  const renderHeader = () =>
    (title || titleComp || onBack || onClose) && (
      <div className={classNames("modal-mnc-head align-items-center", titleClass)}>
        {onBack && (
          <div>
            <Button className="btn button-ktb-close" onClick={onBack}>
              <i className="feather-icon icon-arrow-left"></i>
            </Button>
          </div>
        )}
        {titleComp && <div className="title">{titleComp}</div>}
        <HeaderText>{title}</HeaderText>
        {onClose && (
          <Button className="btn button-ktb-close" onClick={onClose}>
            <i className="feather-icon icon-x"></i>
          </Button>
        )}
      </div>
    );

  const renderFooter = () =>
    !footer ? null : (
      <div className="modal-mnc-footer">
        <div className="row justify-content-center">
          <div className="col-12 px-0">
            <div className="d-grid">{footer}</div>
          </div>
        </div>
      </div>
    );

  return (
    <div {...props}>
      {renderHeader()}
      <div className={clazz("modal-mnc-body py-3 pb-1 px-3 px-lg-4", bodyClass)}>{body ?? children}</div>
      {renderFooter()}
    </div>
  );
};

export default memo(ModalTemplate1);

ModalTemplate1.defaultProps = {
  bodyClass: "",
};

const HeaderText = styled.h5`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
`;
